import React, { useState, useEffect } from "react";
import { useStoreState, useStoreActions } from "easy-peasy";
import converter from "number-to-words";
import Calendar from "./Calendar";
import {
  getYearCalendar,
  getCopticCalendar,
  regularMonths,
  copticMonths,
} from "../utilities/date";
import { metaData } from "../utilities/metaData";
import { getCopticDate, getGregorian } from "../utilities/copticCalendar";
import { upcomingEvents } from "../utilities/upcomingEvents";
import LeftArrow from "../assets/image/arrow-left.svg";
import RightArrow from "../assets/image/arrow-right.svg";

export default function Right() {
  const calendar = useStoreState((state) => state.calendar);
  const isCopticCal = useStoreState((state) => state.isCopticCal);
  const dates = useStoreState((state) => state.dates);
  const copticDate = useStoreState((state) => state.copticDate);
  const activeDate = useStoreState((state) => state.activeDate);
  const upcomings = useStoreState((state) => state.upcomings);
  const currentDate = useStoreState((state) => state.currentDate);

  const setCalendar = useStoreActions((actions) => actions.setCalendar);
  const setDates = useStoreActions((actions) => actions.setDates);
  const setCopticDate = useStoreActions((actions) => actions.setCopticDate);
  const setUpcomings = useStoreActions((actions) => actions.setUpcomings);
  const setActiveDate = useStoreActions((actions) => actions.setActiveDate);
  const setCurrentDate = useStoreActions((actions) => actions.setCurrentDate);
  const [isDateSelected, setDateSelected] = useState(true);
  const [isCurrentMonth, setIsCurrentMonth] = useState(true);

  useEffect(() => {
    if (copticDate === null) {
      setCopticDate(
        getCopticDate(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate()
        )
      );
    } else if (!isCopticCal && dates.year !== null) {
      setCopticDate(getCopticDate(dates.year, dates.month, dates.date));
    } else if (isCopticCal && dates.year !== null) {
      setCopticDate({
        month: copticMonths[dates.month],
        monthIndex: dates.month,
        day: dates.date,
        year: dates.year,
      });
    }
    if (dates.date !== null && copticDate !== null) {
      const nDate = getGregorian(dates.year, dates.month + 1, dates.date);
      const cDate = getCopticDate(dates.year, dates.month, dates.date);
      setActiveDate({
        copticDate: {
          year: isCopticCal ? dates.year : cDate.year,
          month: isCopticCal ? dates.month : cDate.monthIndex,
          date: isCopticCal ? dates.date : cDate.day,
        },
        normalDate: {
          year: isCopticCal ? nDate.year : dates.year,
          month: isCopticCal ? nDate.month : dates.month,
          date: isCopticCal ? nDate.day : dates.date,
        },
      });
      setUpcomings(
        upcomingEvents(
          isCopticCal ? nDate.year : dates.year,
          isCopticCal ? nDate.month : dates.month,
          isCopticCal ? nDate.day : dates.date
        )
      );
    }
  }, [dates.date]);

  useEffect(() => {
    const todayCopticDate = getCopticDate(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );
    const todayNormalDate = {
      date: new Date().getDate(),
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    };

    Promise.all([
      setDateSelected(true),
      setDates({
        date: !isCopticCal ? new Date().getDate() : todayCopticDate.day,
        month: !isCopticCal
          ? new Date().getMonth()
          : todayCopticDate.monthIndex,
        year: !isCopticCal ? new Date().getFullYear() : todayCopticDate.year,
      }),
      setActiveDate({
        copticDate: {
          date: todayCopticDate.day,
          month: todayCopticDate.monthIndex,
          year: todayCopticDate.year,
        },
        normalDate: todayNormalDate,
      }),
    ]);
  }, [currentDate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(new Date().getDate());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setCalendar(
      !isCopticCal
        ? getYearCalendar(
            dates.year === null ? new Date().getFullYear() : dates.year
          )
        : getCopticCalendar(
            dates.year === null ? new Date().getFullYear() : dates.year
          )
    );
  }, [dates.year, isCopticCal]);

  useEffect(() => {
    if (isCopticCal && activeDate.copticDate) {
      setDates({
        date: activeDate.copticDate?.date,
        month: activeDate.copticDate?.month,
        year: activeDate.copticDate?.year,
      });
    } else if (activeDate.normalDate) {
      setDates({
        date: activeDate.normalDate?.date,
        month: activeDate.normalDate?.month,
        year: activeDate.normalDate?.year,
      });
    } else {
      setDates({
        date: new Date().getDate(),
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
      });
    }
  }, [isCopticCal]);

  useEffect(() => {
    if (
      (!isCopticCal &&
        new Date().getFullYear() === dates.year &&
        new Date().getMonth() === dates.month) ||
      (isCopticCal &&
        copticDate.year === dates.year &&
        copticDate.monthIndex === dates.month)
    ) {
      setIsCurrentMonth(true);
    } else {
      setIsCurrentMonth(false);
    }
  }, [isCurrentMonth, dates.month]);

  return (
    <div className="right">
      <div className="month-year">
        <div>
          <button
            className="buttonToday"
            onClick={() => {
              const todayCopticDate = getCopticDate(
                new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate()
              );
              const todayNormalDate = {
                date: new Date().getDate(),
                month: new Date().getMonth(),
                year: new Date().getFullYear(),
              };

              Promise.all([
                setDateSelected(true),
                setDates({
                  date: !isCopticCal
                    ? new Date().getDate()
                    : todayCopticDate.day,
                  month: !isCopticCal
                    ? new Date().getMonth()
                    : todayCopticDate.monthIndex,
                  year: !isCopticCal
                    ? new Date().getFullYear()
                    : todayCopticDate.year,
                }),
                setActiveDate({
                  copticDate: {
                    date: todayCopticDate.day,
                    month: todayCopticDate.monthIndex,
                    year: todayCopticDate.year,
                  },
                  normalDate: todayNormalDate,
                }),
              ]);
            }}
          >
            Today
          </button>
        </div>
        <button
          onClick={() => {
            setDateSelected(false);
            setDates({
              date: dates.date,
              month:
                dates.month === 0 ? (isCopticCal ? 12 : 11) : dates.month - 1,
              year: dates.month === 0 ? dates.year - 1 : dates.year,
            });
          }}
        >
          <img src={LeftArrow} alt="left"></img>
        </button>
        {isCopticCal
          ? copticMonths[dates.month] + " " + dates.year
          : regularMonths[dates.month] + " " + dates.year}
        <button
          onClick={() => {
            setDateSelected(false);
            setDates({
              date: dates.date,
              month:
                dates.month === (isCopticCal ? 12 : 11) ? 0 : dates.month + 1,
              year:
                dates.month === (isCopticCal ? 12 : 11)
                  ? dates.year + 1
                  : dates.year,
            });
          }}
        >
          <img src={RightArrow} alt="right"></img>
        </button>
      </div>
      <Calendar
        data={calendar[dates.month] || []}
        isDateSelected={isDateSelected}
        setDateSelected={setDateSelected}
      />
      <div className="details">
        <div>
          <span>
            The{" "}
            {converter
              .toWordsOrdinal(copticDate?.day || 0)
              .split("-")
              .map((w) => w[0].toUpperCase() + w.substr(1).toLowerCase())
              .join(" ")}{" "}
            Day of the Blessed Month of {copticDate?.month}
          </span>
        </div>
        <div>
          <div className="celebrations">
            <span className="heading">Commermorations</span>
            {metaData[copticDate?.month.split(" ").join("")]
              ?.filter((x) => Number(x.day) === Number(copticDate.day))[0]
              ?.celebrations.map(({ title }) => (
                <div>
                  <span>{title.split(",").join(" ")}</span>
                </div>
              ))}
          </div>

          <div className="upcoming">
            <span className="heading">Upcoming</span>
            {upcomings.map((upcomig) => (
              <div>
                <span>{upcomig.event}</span>
                <span
                  style={{
                    fontWeight: "bold",
                    textDecoration: "underline",
                    marginLeft: "10px",
                  }}
                >
                  {upcomig.formattedDate}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
